
import axios , {AxiosResponse} from "axios";
import {BaseDataObject} from "./ApiBase"
const about = {
    home(): Promise<AxiosResponse<BaseDataObject>> {//获取弹出浮层的标识
        return axios.get(`/user/balance`);
    },
    homecs(): Promise<AxiosResponse<BaseDataObject>> {//获取弹出浮层的标识
        return axios.get(`/home/cs`);
    },
    inviteEntry(): Promise<AxiosResponse<BaseDataObject>> {//获取弹出浮层的标识
        return axios.get(`/invite/inviteEntry`);
    },
    submitWithPic(data:any): Promise<AxiosResponse<BaseDataObject>> {//获取弹出浮层的标识
        return axios.post(`/aliMama/submitWithPic`,data);
    },
};
export default about;